module.exports = __webpack_public_path__ + "img/bottom.f92a3377.png";